<template>
    <v-dialog dark v-model="trade_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

        <v-card>
            <v-toolbar dark color="#262626">
                <v-btn icon dark @click="close">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div style="display:contents;width:calc(100% - 100px);background: rgba(0,0,0,0.1);margin-bottom: -16px;">





                    <v-menu  bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    class="mx-8"
                                    icon
                                    v-on="on"
                                    style="font-size: 0.75rem;"

                                    :xSmall="!$vuetify.breakpoint.lgAndUp"
                            >
                                <v-icon>mdi-sort-descending </v-icon>
                                {{sortBy}}
                            </v-btn>
                        </template>

                        <v-list>
                            <v-subheader>Sortera efter:</v-subheader>
                            <v-list-item
                                    v-for="(item, i) in sortOptions"
                                    :key="i"
                                    style="font-size: 0.75rem;"
                                    @click="sortBy=item.title"
                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-text-field
                            hide-details
                            prepend-icon="search"
                            single-line
                            clearable
                            v-model="filter"
                            style="max-width:25%;min-width:200px;"
                    ></v-text-field>



                </div>
                <v-spacer></v-spacer>
                <v-btn :disabled="!(i_lose.length>0 || i_get.length>0)" dark color="green" @click="sendTradeOffer">
                    Skicka förfrågan
                </v-btn>
            </v-toolbar>

            <v-row>
                <v-col cols="12" style="padding-bottom: 0;">
                    <v-tabs
                            v-model="whose_cards"
                            background-color="transparent"
                            centered

                    >
                        <v-tab

                        >
                            <v-badge
                                    color="black"
                                    :content="my_collection_cards.length>0?my_collection_cards.length:'0'"
                            >
                                Mina kort
                            </v-badge>
                        </v-tab>
                        <v-tab

                        >
                            <v-badge
                                    color="black"
                                    :content="their_collection_cards.length>0?their_collection_cards.length:'0'"
                            >
                                {{namel}} kort
                            </v-badge>
                        </v-tab>
                    </v-tabs>

                </v-col>

                <v-col cols="12">
                    <v-tabs-items :style="{'z-index':(5-drag_top)}" touchless style="background-image: url(/api/images/leather.png);  z-index: 5; background-size: auto; background-repeat: round;box-shadow: inset 0px 80px 66px -20px rgba(0,0,0,0.4);" v-model="whose_cards">
                        <v-tab-item style="background:transparent;height:calc(55vh - 100px);overflow-y:scroll;overflow-x:hidden;" >

                            <v-row style="">
                                <draggable class="row" :list="my_collection_cards" group="people" @start="drag_top=true" @end="drag_top=false"  style="height:100%;width:100%;">

                                <v-col class="col-6 col-md-3 no_pointer" v-for="(card,index) in my_collection_cards" :key="index"  style="width:200px;pointer-events: none;">

                                            <CollectionCard
                                                    v-on:clicked="collection_show=true;selected_collection_card=card"
                                                    v-if="card!==undefined && card.TYPE===0"
                                                    :data=card
                                                    :animate=false
                                                    :key="index"
                                                    style="pointer-events: none;"
                                                    :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"



                                                    :list_index=index
                                            ></CollectionCard>
                                    </v-col>
                                </draggable>

                            </v-row>

                        </v-tab-item>
                        <v-tab-item style="background:transparent;height:calc(55vh - 100px);overflow-y:scroll;overflow-x:hidden;" >
                            <v-row style="">
                                <draggable  class="row"  :list="their_collection_cards" group="people" @start="drag_top=true" @end="drag_top=false"  style="height:100%;min-height:calc(60vh - 100px);;width:100%;">

                                    <v-col class="col-6 col-md-3" v-for="(card,index) in their_collection_cards" :key="index" style="width:200px;pointer-events: none;">

                                        <CollectionCard
                                                v-on:clicked="collection_show=true;selected_collection_card=card"
                                                v-if="card!==undefined && card.TYPE===0"
                                                :data=card
                                                :animate=false

                                                style="pointer-events: none;"
                                                :key="index"
                                                :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"

                                                :list_index=index
                                        ></CollectionCard>
                                    </v-col>
                                </draggable>

                            </v-row>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
                <v-col cols="12" style="margin-top: -24px;">
                    <v-tabs
                            v-model="whose_cards"
                            background-color="transparent"
                            centered

                    >
                        <v-tab

                        >
                            <v-badge
                                    color="black"
                                    :content="i_lose.length>0?i_lose.length:'0'"
                            >
                                {{name}} får
                            </v-badge>
                        </v-tab>
                        <v-tab

                        >
                            <v-badge
                                    color="black"
                                    :content="i_get.length>0?i_get.length:'0'"
                            >
                                Jag får
                            </v-badge>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items touchless style="background:#181818; background-size: auto; background-repeat: round;box-shadow: inset 0px 80px 66px -20px rgba(0,0,0,0.4);z-index: 5;" :style="{'z-index':(5-drag_bot)}" v-model="whose_cards">

                        <v-tab-item style="background:transparent;height:calc(45vh - 100px);overflow-y:scroll;overflow-x:hidden;" >

                            <v-row style="min-height:calc(40vh - 100px);width:100%;">
                                <draggable :list="i_lose" group="people" @start="drag_bot=true" @end="drag_bot=false" class="row" style="height:100%;width:100%;min-height:calc(40vh - 100px);">

                                <v-col v-for="(card,index) in i_lose" :key="index"  class="col-6 col-md-3 no_pointer"  style="width:200px;pointer-events: none;">
                                    <CollectionCard
                                                v-on:clicked="collection_show=true;selected_collection_card=card"
                                                v-if="card!==undefined && card.TYPE===0"
                                                :data=card
                                                :key="index"
                                                :animate=false

                                                style="pointer-events: none;"
                                                :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"

                                                :list_index=index
                                        ></CollectionCard>


                            </v-col>
                                </draggable>


                            </v-row>


                        </v-tab-item>
                        <v-tab-item style="background:transparent;height:calc(45vh - 100px);overflow-y:scroll;overflow-x:hidden;" >

                            <v-row style="min-height:calc(40vh - 100px);width:100%;">
                                <draggable class="row"  :list="i_get" group="people" @start="drag_bot=true" @end="drag_bot=false" style="height:100%;width:100%;min-height:calc(40vh - 100px);">

                                    <v-col v-for="(card,index) in i_get" :key="index"  class="col-6 col-md-3"  style="width:200px;pointer-events: none;" >
                                        <CollectionCard
                                                v-on:clicked="collection_show=true;selected_collection_card=card"
                                                v-if="card!==undefined && card.TYPE===0"
                                                :data=card
                                                :key="index"
                                                :animate=false

                                                style="pointer-events: none;"
                                                :style="{'transform':$vuetify.breakpoint.mdAndDown?'scale(0.7)':''}"

                                                :list_index=index
                                        ></CollectionCard>


                                    </v-col>
                                </draggable>


                            </v-row>
                        </v-tab-item>
                    </v-tabs-items>

                </v-col>


            </v-row>

        </v-card>
        <CollectioncardHolder

                :showoff=true
                :show-arrows=false

                :show=collection_show
                :card_data=selected_collection_card
                v-on:hide="collection_show=false"



        ></CollectioncardHolder>
    </v-dialog>
</template>

<script>
    import draggable from 'vuedraggable'
    import CollectioncardHolder from  '../components/CollectioncardHolder'
    import CollectionCard from  '../components/CollectionCard'
    export default {
        name: "TradeDialog",
        props:["trade_dialog","namel","name"],
        components:{CollectionCard,draggable,CollectioncardHolder},
        data:function(){
          return{
              collection_show:false,
              selected_collection_card:null,
              whose_cards:0,
              sortOptions:[
                  {title:"Nyast",value:"date"},
                  {title:"Dekor",value:"tier"},
                  {title:"Namn",value:"name"},
                  {title:"Float",value:"float"},
                  {title:"Streamer",value:"streamer"}
              ],
              sortBy:"Namn",
              typeShow:"Alla",
              filter:"",
              showOptions:[
                  {title:"Alla"},
                  {title:"Action"},
                  {title:"Collection"},
                  {title:"Packs"}
              ],
              my_collection_cards_unfiltered:[],
              my_collection_cards:[],
              their_collection_cards_unfiltered:[],
              their_collection_cards:[],
              i_get:[],
              i_lose:[],
              drag_bot:false,
              drag_top:true
          }
        },
        methods:{

            filterFuncMy:function(newVal,oldVal){

                if(newVal==="" || newVal===null){
                    this.my_collection_cards=this.my_collection_cards_unfiltered;
                    this.their_collection_cards=this.their_collection_cards_unfiltered;

                }
                else if(oldVal.includes(newVal) && newVal.length>oldVal.length){

                    let searchParams=newVal.split(" ");
                    let sorted=this.my_collection_cards;
                    for(let i=0;i<searchParams.length;i++){
                        sorted = sorted.filter(card => card.USER_NAME.toLowerCase().includes(searchParams[i].toLowerCase()) || card.NAME.toLowerCase().includes(searchParams[i].toLowerCase()))
                    }
                    this.my_collection_cards=sorted;
                }
                else{

                    let searchParams=newVal.split(" ");
                    let sorted=this.my_collection_cards_unfiltered;
                    for(let i=0;i<searchParams.length;i++){
                        sorted = sorted.filter(card => card.USER_NAME.toLowerCase().includes(searchParams[i].toLowerCase()) || card.NAME.toLowerCase().includes(searchParams[i].toLowerCase()))
                    }
                    this.my_collection_cards=sorted;

                }
            },
            filterFuncTheir:function(newVal,oldVal){

                if(newVal==="" || newVal===null){
                    this.their_collection_cards=this.their_collection_cards_unfiltered;
                    this.their_collection_cards=this.their_collection_cards_unfiltered;

                }
                else if(oldVal.includes(newVal) && newVal.length>oldVal.length){

                    let searchParams=newVal.split(" ");
                    let sorted=this.their_collection_cards;
                    for(let i=0;i<searchParams.length;i++){
                        sorted = sorted.filter(card => card.USER_NAME.toLowerCase().includes(searchParams[i].toLowerCase()) || card.NAME.toLowerCase().includes(searchParams[i].toLowerCase()))
                    }
                    this.their_collection_cards=sorted;
                }
                else{

                    let searchParams=newVal.split(" ");
                    let sorted=this.their_collection_cards_unfiltered;
                    for(let i=0;i<searchParams.length;i++){
                        sorted = sorted.filter(card => card.USER_NAME.toLowerCase().includes(searchParams[i].toLowerCase()) || card.NAME.toLowerCase().includes(searchParams[i].toLowerCase()))
                    }
                    this.their_collection_cards=sorted;

                }
            },



            close:function(){
                this.$emit('close')
            },
            get_my_collection_cards(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id=this.$store.state.STREAMER.SID;
                this.sid=id;
                let url = '/api/get_cards?id='+id;
                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.loaded=true;
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);
                            self.my_collection_cards=data;
                            self.my_collection_cards_unfiltered=data;
                        }

                    }

                };
                http.send();
            },
            get_their_collection_cards(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id=window.location.pathname.substring(11);
                //this.sid=id;
                let url = '/api/get_cards?id='+id;
                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.loaded=true;
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);
                            self.their_collection_cards=data;
                            self.their_collection_cards_unfiltered=data;
                        }

                    }

                };
                http.send();
            },
            sendTradeOffer() {
                let cardslostids = [];
                let cardsgottenids = [];
                let id=window.location.pathname.substring(11);
                [...this.i_lose].forEach((element) => {
                    cardslostids.push(element.CID);
                });
                [...this.i_get].forEach((element) => {
                    cardsgottenids.push(element.CID);

                });
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/create_trade';
                let self=this;
                http.open("POST", url, true);
                http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                http.onreadystatechange = function () {

                    if (http.readyState === 4) {
                        if(http.status === 403){

                            console.log("error");
                            self.$store.commit("update_snackbar","Ett fel inträffade");


                        }
                        else {
                            self.$store.commit("update_snackbar","Förfrågan skickad");
                            self.$store.dispatch("get_num_trades");

                            self.close();

                        }

                    }
                };
                http.send(JSON.stringify({"lost": cardslostids, "gotten": cardsgottenids,"counterpart":id}));

            }
        },
        watch:{

            trade_dialog:  {
                immediate: true,
                handler() {
                    this.i_get=[];
                    this.i_lose=[];
                    if(this.trade_dialog){
                        this.get_my_collection_cards();
                        this.get_their_collection_cards();
                    }
                }
            },

            filter:function(newVal,oldVal){

                this.filterFuncMy(newVal,oldVal);
                this.filterFuncTheir(newVal,oldVal);

            },
            sortBy:function(newVal){
                if(newVal==="Namn"){
                    this.my_collection_cards.sort(function(a, b){
                        var nameA=a.NAME.toLowerCase(), nameB=b.NAME.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });
                    this.their_collection_cards.sort(function(a, b){
                        var nameA=a.NAME.toLowerCase(), nameB=b.NAME.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Streamer"){
                    this.my_collection_cards.sort(function(a, b){
                        var nameA=a.USER_NAME.toLowerCase(), nameB=b.USER_NAME.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });
                    this.their_collection_cards.sort(function(a, b){
                        var nameA=a.USER_NAME.toLowerCase(), nameB=b.USER_NAME.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Dekor"){
                    this.my_collection_cards.sort(function(a, b){
                        var rankA,rankB;

                            rankA=a.RANK_VALUE;
                            rankB=b.RANK_VALUE;
                        if (rankA > rankB)
                            return -1;
                        if (rankA < rankB)
                            return 1;
                        return 0;
                    });
                    this.their_collection_cards.sort(function(a, b){
                        var rankA,rankB;

                        rankA=a.RANK_VALUE;
                        rankB=b.RANK_VALUE;
                        if (rankA > rankB)
                            return -1;
                        if (rankA < rankB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Float"){
                    this.my_collection_cards.sort(function(a, b){
                        var floatA,floatB;
                        floatA=(Math.sqrt((a.FLOAT_X*a.FLOAT_X)+(a.FLOAT_Y*a.FLOAT_Y))/Math.sqrt(2));
                        floatB=(Math.sqrt((b.FLOAT_X*b.FLOAT_X)+(b.FLOAT_Y*b.FLOAT_Y))/Math.sqrt(2));
                        if (floatA < floatB)
                            return -1;
                        if (floatA > floatB)
                            return 1;
                        return 0;
                    });
                    this.their_collection_cards.sort(function(a, b){
                        var floatA,floatB;
                        floatA=(Math.sqrt((a.FLOAT_X*a.FLOAT_X)+(a.FLOAT_Y*a.FLOAT_Y))/Math.sqrt(2));
                        floatB=(Math.sqrt((b.FLOAT_X*b.FLOAT_X)+(b.FLOAT_Y*b.FLOAT_Y))/Math.sqrt(2));
                        if (floatA < floatB)
                            return -1;
                        if (floatA > floatB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Nyast"){
                    this.my_collection_cards.sort(function(a, b){
                        var dateA = new Date(a.DATE_REG);
                        var dateB = new Date(b.DATE_REG);



                        if (dateA.getTime() < dateB.getTime())
                            return 1;
                        if (dateA.getTime() > dateB.getTime())
                            return -1;
                        return 0;
                    });
                    this.their_collection_cards.sort(function(a, b){
                        var dateA = new Date(a.DATE_REG);
                        var dateB = new Date(b.DATE_REG);



                        if (dateA.getTime() < dateB.getTime())
                            return 1;
                        if (dateA.getTime() > dateB.getTime())
                            return -1;
                        return 0;
                    });
                }

            }

        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #000000;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #757575;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:#373834;
    }

</style>
